import { CostCenter } from './cost-center.model';
import { ShiftBlock } from './shift-block.model';
import { PatientCensusRecord } from './patient-census-record.model';
import { StaffingPlan } from './staffing-plan.model';
import { CensusSnapshot } from './census-snapshot.model';
import { MeasureRecord } from './measure-record.model';
import { VarianceReasonRecord } from './variance-reason-record.model';
import { PatientRatioRecord } from './patient-ratio-record.model';
import { User } from './user.model';
import { RoomAcuityRecord } from './room-acuity-record.model';
import { AcuityCensusRecord } from './acuity-census-record.model';
import { UnitOfServiceRecord } from './unit-of-service-record.model';
import { Client } from './client.model';

export class ShiftRecord {
    id: number;
    costCenterId: number;
    workflowTime: string;
    workflowTimeFacility: string;
    shiftBlockId: number;
    prevShiftRecordId?: number;
    user: User;
    userId: number;
    costCenter: CostCenter;
    shiftBlock: ShiftBlock;
    prevShiftRecord?: ShiftRecord;
    patientCensusRecord?: PatientCensusRecord;
    staffingPlans: StaffingPlan[];
    projectedCensusChurn: CensusSnapshot;
    actualCensusChurn?: CensusSnapshot;
    measureRecords: MeasureRecord[];
    varianceReasonRecords: VarianceReasonRecord[];
    patientRatioRecords?: PatientRatioRecord[];
    status: string;
    roomAcuityRecords: RoomAcuityRecord[];
    acuityCensusRecords: AcuityCensusRecord[];
    unitOfServiceRecords?: UnitOfServiceRecord[];
    modelCreatedTimeUtc?: Date;
}
